import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../../Slice/loading/loadingSlice";
import authApi from "../../authApi";
import { setApprovedLinguistInvoiceList, setClientInvoice, setClientInvoiceCreation, setClientInvoiceListCount, setClientInvoicePartPayments, setClientScoopData, setDownloadPdf, setEmailTemplate, setFreelanceInvoicePartPayments, setLinguistInvoice, setUsers } from "../../Slice/InvoiceModule/InvoiceSlice";
import { showSnackbar } from "../../Slice/snackbar/snackbarSlice";


export const usersList = createAsyncThunk(
  "users/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/users`);
      if (response?.status === 200) {
        dispatch(setUsers(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const linguistInvoiceList = createAsyncThunk(
  "getLinguistInvoiceList/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/getLinguistInvoiceList`, request);
      if (response?.status === 200) {
        dispatch(setLinguistInvoice(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getApprovedLinguistInvoiceList = createAsyncThunk(
  "getApprovedLinguistInvoiceList/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/getApprovedLinguistInvoiceList`, request);
      if (response?.status === 200) {
        dispatch(setApprovedLinguistInvoiceList(response?.data));
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const freelanceInvoiceExcelStatus = createAsyncThunk(
  "freelanceInvoiceExcelStatus",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/freelanceInvoiceExcelStatus`, request);
      if (response?.status === 200) {
        return response?.data;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const saveDueDate = createAsyncThunk(
  "freelanceInvoiceDueDate/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/freelanceInvoiceDueDate`, request);
      return response
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const deleteFreelancerInvoice = createAsyncThunk(
  "deleteFreelancerInvoice",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.delete(`/deleteFreelancerInvoice/${request}`);
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const linguistInvoiceRequestUpdate = createAsyncThunk(
  "linguistInvoiceRequestUpdate",
  async (request, { dispatch }) => {
    // dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/linguistInvoiceRequestUpdate`, request);
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getClientInvoice = createAsyncThunk(
  "clientInvoiceApprovedScoop",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/clientInvoiceApprovedScoop/1?perPage=${request.length}&page=${request.page + 1}`);
      if (response.status === 200) {
        dispatch(setClientInvoiceCreation(response?.data))
        dispatch(setLoading(false))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getclientInvoiceListCount = createAsyncThunk(
  "getclientInvoiceListCount",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/getclientInvoiceListCount`);
      if (response.status === 200) {
        dispatch(setClientInvoiceListCount(response?.data))
        dispatch(setLoading(false))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const downloadinvoiceClient = createAsyncThunk(
  "downloadinvoice",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/downloadinvoice`, request);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        dispatch(setLoading(false))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getClientInvoiceList = createAsyncThunk(
  "getclientInvoiceList",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/getclientInvoiceList`, request);
      if (response.data?.success === true) {
        dispatch(setClientInvoice(response?.data))
        dispatch(setLoading(false))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const createInvoiceCreditnotes = createAsyncThunk(
  "createInvoiceCreditnotes",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/createInvoiceCreditnotes`, request);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        dispatch(setLoading(false))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const deleteClientInvoice = createAsyncThunk(
  "deleteClientInvoice",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.delete(`/deleteInvoice/${request}`);
      dispatch(
        showSnackbar({
          message: response?.data?.msg,
          type: "success",
        })
      );
      return response
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const saveClientInvoiceDueDate = createAsyncThunk(
  "freelanceInvoiceDueDate/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/clientInvoiceDueDate`, request);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const clientinvoiceSave = createAsyncThunk(
  "clientinvoiceSave/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/clientinvoiceSave`, request);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: "Invoice Successfully Created",
            type: "success",
          })
        );
        return response
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg,
          type: "error",
        })
      );
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getClientScoopData = createAsyncThunk(
  "getClientScoopData/list",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/getClientScoopData/${request}`);
      if (response.status === 200) {
        dispatch(setClientScoopData(response?.data))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const updateScoopIds = createAsyncThunk(
  "updateScoopIds/delete",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    const { id, payload } = request;
    try {
      const response = await authApi.put(`/updateScoopIds/${id}`, payload);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg || "Updated Successfully",
            type: "success",
          })
        );
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const saveEditedInvoice = createAsyncThunk(
  "updateScoopIds/delete",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    const { id, payload } = request;
    try {
      const response = await authApi.put(`/saveEditedInvoice/${id}`, payload);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const clientInvoiceStatusChange = createAsyncThunk(
  "clientInvoiceStatusChange/cancel",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    const { id, payload } = request;
    try {
      const response = await authApi.put(`/clientInvoiceStatusChange/${id}`, payload);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const invoiceStatusIrrecoverable = createAsyncThunk(
  "invoiceStatusIrrecoverable",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    const { id, payload } = request;
    try {
      const response = await authApi.put(`/invoiceStatusIrrecoverable/${id}`, payload);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const invoiceSave = createAsyncThunk(
  "invoiceSave/",
  async (request, { dispatch, rejectWithValue }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/invoiceSave`, request, { headers: { "Content-Type": "multipart/form-data" } });
      if (response.status === 200 && response?.data?.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response;
      }
      // HTTP 200 with a non-success business status in the body
      const errorPayload = response?.data || { msg: "Failed to save invoice." };
      dispatch(
        showSnackbar({
          message: errorPayload?.msg || "Failed to save invoice.",
          type: "error",
        })
      );
      return rejectWithValue(errorPayload);
    } catch (error) {
      dispatch(
        showSnackbar({
          message: error?.response?.data?.msg || "Failed to save invoice.",
          type: "error",
        })
      );
      console.error("API Error:", error);
      return rejectWithValue(error?.response?.data || { msg: "Failed to save invoice." });
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getFreelanceInvoicePartPayments = createAsyncThunk(
  "getFreelanceInvoicePartPayments/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/getFreelanceInvoicePartPayments/${request}`);
      if (response.status === 200) {
        dispatch(setFreelanceInvoicePartPayments(response?.data))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getClientInvoicePartPayments = createAsyncThunk(
  "getClientInvoicePartPayments/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.get(`/getClientInvoicePartPayments/${request}`);
      if (response.status === 200) {
        dispatch(setClientInvoicePartPayments(response?.data))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const invoiceStatusApproved = createAsyncThunk(
  "invoiceStatusApproved/",
  async ({ id, ...payload }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/invoiceStatusApproved/${id}`, payload); // ✅ payload sent, id used in URL
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const saveEditedInvoiceLinguist = createAsyncThunk(
  "saveEditedInvoiceLinguist/",
  async ({ id, ...payload }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/saveEditedInvoiceLinguist/${id}`, payload); // ✅ payload sent, id used in URL
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const invoiceStatusChange = createAsyncThunk(
  "invoiceStatusChange/",
  async ({ id, ...payload }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/invoiceStatusChange/${id}`, payload); // ✅ payload sent, id used in URL
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const invoiceStatusChangeBulk = createAsyncThunk(
  "invoiceStatusChangeBulk/",
  async ({ invoice_ids, ...payload }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/invoiceStatusChangeBulk`, {
        invoice_ids,
        ...payload,
      });
      if (response.status === 200) {
        // Bulk endpoint may return partial failures; let UI decide snackbar tone.
        return response;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const clientInvoiceStatusChangeBulk = createAsyncThunk(
  "clientInvoiceStatusChangeBulk/",
  async ({ invoice_ids, ...payload }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.put(`/clientInvoiceStatusChangeBulk`, {
        invoice_ids,
        ...payload,
      });
      if (response.status === 200) {
        // Bulk endpoint may return partial failures; let UI decide snackbar tone.
        return response;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const deleteLinguistInvoicePayment = createAsyncThunk(
  "getFreelanceInvoicePartPayments/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.delete(`/deleteLinguistInvoicePayment/${request}`);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        );
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const getEmailTemplate = createAsyncThunk(
  "getEmailTemplate/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      // Build query parameters conditionally
      const params = new URLSearchParams();
      if (request.templateId) {
        params.append('templateId', request.templateId);
      }
      params.append('userId', request.userId);
      
      const response = await authApi.get(`/getEmailTemplate?${params.toString()}`);
      
      if (response.status === 200) {
        dispatch(setEmailTemplate(response?.data))
        return response
      }
    } catch (error) {
      dispatch(setEmailTemplate([]));
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const sendClientInvoiceMail = createAsyncThunk(
  "sendClientInvoiceMail/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/sendClientInvoiceMail`, request);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        )
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const sendInvoiceMail = createAsyncThunk(
  "sendInvoiceMail/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/sendInvoiceMail`, request);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        )
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const sendgeneralMsg = createAsyncThunk(
  "sendgeneralMsg/",
  async (request, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/sendgeneralMsg`, request);
      if (response.status === 200) {
        dispatch(
          showSnackbar({
            message: response?.data?.msg,
            type: "success",
          })
        )
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const downloadInvoicePDF = createAsyncThunk(
  "downloadInvoicePDF",
  async (request, { dispatch }) => {
    const { id, is_base64, dowload_type } = request;

    const queryParams = new URLSearchParams();
    if (is_base64) queryParams.append("is_base64", "1");

    const query = queryParams.toString() ? `?${queryParams.toString()}` : "";

    // Construct body conditionally
    const body = { id };
    if (dowload_type) body.dowload_type = dowload_type;

    dispatch(setLoading(true));
    try {
      const response = await authApi.post(
        `/downloadInvoicePDF${query}`,
        body,
        {
          responseType: is_base64 ? "json" : "blob",
        }
      );

      if (response.status === 200) {
        dispatch(setDownloadPdf(response?.data));
        return response;
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const downloadFreelanceInvoicePDF = createAsyncThunk(
  "downloadFreelanceInvoicePDF",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const { id, is_system_genrated, is_base64, dowload_type } = payload;

      // Build query string dynamically
      const queryParams = new URLSearchParams();
      if (is_system_genrated) queryParams.append("is_system_genrated", "true");
      if (is_base64) queryParams.append("is_base64", "1");

      const query = queryParams.toString() ? `?${queryParams.toString()}` : "";

      // Dynamically build request body
      const requestBody = { id };
      if (dowload_type) requestBody.dowload_type = dowload_type;

      const response = await authApi.post(
        `/downloadFreelanceInvoicePDF${query}`,
        requestBody,
        {
          responseType: is_base64 ? "json" : "blob",
        }
      );

      if (response.status === 200) {
        return response;
      }
    } catch (error) {
      console.error("API Error:", error);
      return rejectWithValue(error.response?.data || error.message);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const downloadInvoiceFile = createAsyncThunk(
  "downloadInvoiceFile",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.get(`/downloadInvoiceFile/${request}`, {
        responseType: 'blob',
      });

      if (response.status === 200) {
        return response;
      }
    } catch (error) {
      // Handle blob error response
      let errorMsg = "An unknown error occurred.";

      if (error.response && error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text(); // Convert blob to text
          const json = JSON.parse(text); // Parse text to JSON
          errorMsg = json?.msg || errorMsg;
        } catch (parseError) {
          console.error("Error parsing blob response:", parseError);
        }
      }

      dispatch(showSnackbar({
        message: errorMsg,
        type: "error",
      }));

      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const downloadInvoiceWord = createAsyncThunk(
  "downloadInvoiceWord",
  async (request, { dispatch }) => {
    try {
      const response = await authApi.post(`/downloadInvoiceWord`, request, {
        responseType: 'blob', // 👈 necessary for file download
      });

      const contentDisposition = response.headers['content-disposition'];
      let filename = 'invoice.docx'; // fallback

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) {
          filename = match[1];
        }
      }

      return {
        blob: response.data,
        filename,
      };
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
export const updateClientInvoiceExcelStatus = createAsyncThunk(
  "downloadinvoice",
  async (request, { dispatch }) => {
    //dispatch(setLoading(true));
    try {
      const response = await authApi.post(`/clientInvoiceExcelStatus`, request);
      if (response.status === 200) {
        // dispatch(
        //   showSnackbar({
        //     message: response?.data?.msg,
        //     type: "success",
        //   })
        // );
        // dispatch(setLoading(false))
        return response
      }
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }
);
